export default __webpack_public_path__ + "static/media/icon_facility_cigar.1f9fada2.svg";